import { IconPropsType } from '..';

export const GugulOriginalsIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.300781 7.2V13.3H2.80078V15.8H17.7008V6.9L14.2008 9V12.4H3.80078V7.3C3.80078 5.3 5.40078 3.6 7.50078 3.6H17.7008V0H7.50078C3.50078 0 0.300781 3.2 0.300781 7.2Z"
      fill="white"
    />
  </svg>
);
